import { Phone } from "lucide-react";
import { Link, NavLink } from "react-router-dom";

export function SiteHeader() {
  return (
    <header className="border-b sticky top-0 z-40 bg-background/80 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="mx-auto max-w-6xl px-4 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <img
            src="https://storage.stardeck.ai/images/c20b01ea-c4ec-47f4-96e2-56dc28dcef23.svg"
            alt="Pro Systems logo"
            className="h-8 w-auto"
          />
          <span className="font-semibold tracking-tight">Pro Systems</span>
        </Link>
        <nav className="hidden md:flex items-center gap-6 text-sm">
          <NavLink
            to="/"
            className={({ isActive }) =>
              isActive ? "text-foreground" : "text-muted-foreground hover:text-foreground"
            }
          >
            Home
          </NavLink>
          <NavLink
            to="/about"
            className={({ isActive }) =>
              isActive ? "text-foreground" : "text-muted-foreground hover:text-foreground"
            }
          >
            About
          </NavLink>
          <NavLink
            to="/services"
            className={({ isActive }) =>
              isActive ? "text-foreground" : "text-muted-foreground hover:text-foreground"
            }
          >
            Services
          </NavLink>
          <NavLink
            to="/contact"
            className={({ isActive }) =>
              isActive ? "text-foreground" : "text-muted-foreground hover:text-foreground"
            }
          >
            Contact
          </NavLink>
        </nav>
        <a
          href="tel:0804685545"
          className="inline-flex items-center gap-2 rounded-md bg-accent px-3 py-2 text-sm font-medium text-accent-foreground hover:opacity-90"
        >
          <Phone className="size-4" /> Call us
        </a>
      </div>
    </header>
  );
}
